const businessDiagnosisDictIT = {
  businessDiagnosis: "Valutazione dell'azienda",
  businessDiagnosisSubtitle:
    "Gentile Imprenditore, di seguito una serie di domande al fine di rendere ancora di più la tua azienda EFFICIENTE – EFFICACE – ECONOMICA E SOSTENIBILE. Ingegno, dedizione, professionalità e condivisione ci consentiranno di fare un percorso virtuoso insieme.",

  businessDiagnosisMenuSelection: "Menu di selezione",

  businessDiagnosisInProgress: "Diagnosi Aziendale in Sospeso",
  businessDiagnosisProgressDescription:
    "Scopri come rendere la tua azienda più economica e sostenibile.",
  businessDiagnosisProgressLabel: "Avanzamento:",
  businessDiagnosisProgressStep: "Fase {current} di {total}",
  businessDiagnosisContinue: "Continua la Diagnosi",

  businessDiagnosisStep1Title: "Anagrafica Azienda",
  businessDiagnosisStep2Title: "Struttura Aziendale",
  businessDiagnosisStep3Title: "Dimensione Azienda",
  businessDiagnosisStep4Title: "Capitale Umano Sesso",
  businessDiagnosisStep5Title: "Capitale Umano Mansioni",
  businessDiagnosisStep6Title: "Capitale Umano",
  businessDiagnosisStep7Title: "Rappresentanze",
  businessDiagnosisStep8Title: "Altre info",

  businessDiagnosisStep1Description:
    "Inserisci i dati generali della tua azienda per aiutarci a capire meglio la tua identità e il contesto in cui operi.",
  businessDiagnosisStep2Description:
    "Descrivi la composizione e l'organizzazione interna della tua azienda per comprendere la sua solidità e capacità operativa.",
  businessDiagnosisStep3Description:
    "Specifica la dimensione della tua impresa per orientarci meglio nel valutare le tue esigenze e il tuo potenziale di crescita.",
  businessDiagnosisStep4Description:
    "Raccontaci di quanti collaboratori dispone la tua azienda e delle loro competenze, così da valorizzare il tuo capitale umano.",
  businessDiagnosisStep5Description:
    "Specifica le principali mansioni e responsabilità dei dipendenti, evidenziando i ruoli chiave per la crescita aziendale.",
  businessDiagnosisStep6Description:
    "Inserisci i dati relativi al personale impiegato nella tua azienda, suddiviso per ruoli, competenze e aree operative.",
  businessDiagnosisStep7Description:
    "Fornisci informazioni sulle eventuali rappresentanze legali o commerciali della tua azienda, sia a livello nazionale che internazionale.",
  businessDiagnosisStep8Description:
    "Spiega come la tua azienda utilizza strumenti tecnologici e strategie innovative per rimanere competitiva.",

  back: "Indietro",
  saveAndContinue: "Salva e continua",
  sendDiagnosis: "Invia Diagnosi",

  businessDiagnosisConsent: "I consent",
  businessDiagnosisConsentText:
    "I consent to the use of the information provided for a free assessment for the EXTRACONOMY platform and authorize the processing of data in accordance with current legislation and GDPR.",

  // Shared helpers
  select: "Seleziona",
  businessDiagnosisNoData: "—",

  // Step 1
  businessDiagnosisStep1LabelCompanyName: "Ragione Sociale",
  businessDiagnosisStep1LabelRegisteredOffice: "Sede Legale",
  businessDiagnosisStep1LabelAddress: "Indirizzo",
  businessDiagnosisStep1LabelVatNumber: "P. IVA",
  businessDiagnosisStep1LabelAtecoCode: "Codice ATECO",
  businessDiagnosisStep1LabelSector: "Settore",
  businessDiagnosisStep1LabelLegalRepresentative: "Rapp. Legale",
  businessDiagnosisStep1LabelPhone: "Telefono",
  businessDiagnosisStep1LabelAdministrativeRepresentative: "Rapp. Amm.vo",
  businessDiagnosisStep1LabelWebsite: "Sito web",
  businessDiagnosisStep1PlaceholderWebsite: "https://",
  businessDiagnosisStep1LabelEmail: "E-mail",
  businessDiagnosisStep1LabelCompanyDescription: "Breve descrizione dell'azienda",
  businessDiagnosisStep1PlaceholderCompanyDescription:
    "Breve descrizione della mission e attività.",
  businessDiagnosisStep1LabelLawFirm: "Studio Legale",
  businessDiagnosisStep1LabelAccountingFirm: "Studio Comm.le",
  businessDiagnosisStep1LabelLaborConsultant: "Cons.te Lavoro",

  // Step 2
  businessDiagnosisStep2OrganizationalChartLabel: "Organigramma",
  businessDiagnosisStep2OrganizationalChartHelp: "L'azienda ha un organigramma?",
  businessDiagnosisStep2CompanyRegulationsLabel: "Regolamento Aziendale",
  businessDiagnosisStep2CompanyRegulationsHelp: "Esiste un regolamento interno?",
  businessDiagnosisStep2OrganizationalModel231Label: "Modello Organizzativo 231/01",
  businessDiagnosisStep2OrganizationalModel231Help: "Adotta il Modello 231/01?",
  businessDiagnosisStep2ModelOt23Label: "Modello OT23 - ISI INAIL",
  businessDiagnosisStep2ModelOt23Help: "L'azienda applica modelli OT23/INAIL?",
  businessDiagnosisStep2CodeOfEthicsLabel: "Codice Etico",
  businessDiagnosisStep2CodeOfEthicsHelp: "L'azienda ha un codice etico?",
  businessDiagnosisStep2LegalityRatingLabel: "Rating di Legalità",
  businessDiagnosisStep2LegalityRatingHelp: "Ha ottenuto un rating di legalità?",
  businessDiagnosisStep2SustainabilityReportLabel: "Bilancio di Sostenibilità",
  businessDiagnosisStep2SustainabilityReportHelp: "Pubblica bilanci di sostenibilità?",
  businessDiagnosisStep2SecondaryOfficesLabel: "Sedi secondarie",
  businessDiagnosisStep2SecondaryOfficesHelp: "Ci sono sedi secondarie?",
  businessDiagnosisStep2SecondaryOfficesWhere: "Se Sì indicare dove",
  businessDiagnosisStep2IndustryAssociationLabel: "Iscrizioni ad associazioni di categoria",
  businessDiagnosisStep2IndustryAssociationHelp: "Adesione ad associazioni di categoria.",
  businessDiagnosisStep2IndustryAssociationWhich: "Se Sì indicare quali",
  businessDiagnosisStep2InterprofessionalFundsLabel: "Fondi Interprofessionali",
  businessDiagnosisStep2InterprofessionalFundsHelp: "Partecipazione a fondi interprofessionali.",
  businessDiagnosisStep2InterprofessionalFundsWhich: "Se SI indicare quale/i",
  businessDiagnosisStep2BilateralEntityLabel: "Ente Bilaterale",
  businessDiagnosisStep2BilateralEntityHelp: "È iscritta a un ente bilaterale?",
  businessDiagnosisStep2BilateralEntityWhich: "Se SI indicare quale",

  // Step 3
  businessDiagnosisStep3LabelEmployees: "Nr. Dipendenti",
  businessDiagnosisStep3EmployeesHelp: "Indica la dimensione dell'azienda in base ai dipendenti.",
  businessDiagnosisStep3LabelRevenue: "Fatturato",
  businessDiagnosisStep3RevenueHelp: "Indica la fascia di fatturato annuale.",

  businessDiagnosisSizeEmployeesMicro: "Micro impresa (<10)",
  businessDiagnosisSizeEmployeesSmall: "Piccola impresa (10-49)",
  businessDiagnosisSizeEmployeesMedium: "Media impresa (50-249)",
  businessDiagnosisSizeEmployeesLarge: "Grande impresa (250+)",

  businessDiagnosisSizeRevenueLte2: "Fino a 2 milioni",
  businessDiagnosisSizeRevenue2To10: "2-10 milioni",
  businessDiagnosisSizeRevenue10To50: "10-50 milioni",
  businessDiagnosisSizeRevenueGt50: "Oltre 50 milioni",

  // Step 4
  businessDiagnosisStep4LabelTotalEmployees: "Nr. TOTALE DI DIPENDENTI",
  businessDiagnosisStep4LabelWomen: "Donne",
  businessDiagnosisStep4GenderDistributionHelp: "Distribuzione di genere.",
  businessDiagnosisStep4LabelMen: "Uomini",
  businessDiagnosisStep4LabelOtherGender: "Altro sesso",

  // Step 5
  businessDiagnosisStep5InternalHrLabel: "H.R. interno",
  businessDiagnosisStep5InternalHrHelp: "Indicare se esiste un ufficio o responsabile HR interno.",
  businessDiagnosisStep5SecondLevelContractLabel: "Contratto II Livello",
  businessDiagnosisStep5SecondLevelContractHelp:
    "Indicare se l'azienda applica contratti di secondo livello (integrazioni al CCNL).",
  businessDiagnosisStep5OngoingLaborDisputesLabel: "Vertenze sindacali in corso",
  businessDiagnosisStep5OngoingLaborDisputesHelp:
    "Indicare se ci sono vertenze sindacali attualmente in corso.",
  businessDiagnosisStep5ConcludedLaborDisputesLabel: "Vertenze sindacali concluse",
  businessDiagnosisStep5ConcludedLaborDisputesHelp:
    "Indicare se l'azienda ha concluso vertenze sindacali in passato.",
  businessDiagnosisStep5UnionRepresentativesLabel: "Rappresentanti Sindacali",
  businessDiagnosisStep5UnionRepresentativesHelp:
    "Indicare se ci sono rappresentanti sindacali attivi in azienda.",
  businessDiagnosisStep5UnionRepresentativesWhichLabel: "Se Si quali",
  businessDiagnosisStep5UnionRepresentativesWhichHelp:
    'Se hai risposto "SI" sopra, specificare quali contratti, vertenze o rappresentanti.',
  businessDiagnosisStep5AppliedCcnlLabel: "CCNL Applicato",
  businessDiagnosisStep5AppliedCcnlPlaceholder:
    "Indicare quale CCNL (Contratto Collettivo Nazionale del Lavoro) viene applicato in azienda.",

  // Step 6
  businessDiagnosisStep6StaffingAgenciesLabel: "Utilizzo di Agenzie per il Lavoro",
  businessDiagnosisStep6StaffingAgenciesHelp:
    "Indica se l'azienda utilizza agenzie esterne per la selezione e gestione del personale.",
  businessDiagnosisStep6DirectSeveranceLabel: "Gestione diretta del TFR",
  businessDiagnosisStep6DirectSeveranceHelp:
    "Segnala se l'azienda gestisce internamente il Trattamento di Fine Rapporto dei dipendenti.",
  businessDiagnosisStep6UseTfmLabel: "Utilizzo di polizze TFM",
  businessDiagnosisStep6UseTfmHelp:
    "Specifica se l'azienda utilizza polizze TFM (Trattamento di Fine Mandato) per gli amministratori.",
  businessDiagnosisStep6UseKmanLabel: "Utilizzo di polizze KMAN",
  businessDiagnosisStep6UseKmanHelp:
    "Indica se sono attive polizze assicurative KMAN per figure chiave dell'azienda.",
  businessDiagnosisStep6CorporateWelfareLabel: "Welfare Aziendale",
  businessDiagnosisStep6CorporateWelfareHelp:
    "Indica se l'azienda offre un piano di welfare aziendale (benefici e servizi per i dipendenti).",
  businessDiagnosisStep6HealthWelfareLabel: "Welfare Sanitario",
  businessDiagnosisStep6HealthWelfareHelp:
    "Segnala se l'azienda offre polizze o servizi di welfare sanitario ai dipendenti.",

  // Step 7
  businessDiagnosisStep7RsaLabel: "RSA - Rappresentante Sindacale Aziendale",
  businessDiagnosisStep7RsaHelp:
    "Indicare se l'azienda ha un rappresentante sindacale per i soli iscritti al sindacato.",
  businessDiagnosisStep7RsuLabel: "RSU - Rappresentante Sindacale Unitario",
  businessDiagnosisStep7RsuHelp:
    "Segnalare se esiste un rappresentante che tutela tutti i lavoratori, iscritti e non iscritti.",
  businessDiagnosisStep7RpsLabel: "RPS - Rappresentante per la Sicurezza",
  businessDiagnosisStep7RpsHelp:
    "Specificare se i lavoratori hanno nominato un rappresentante per la sicurezza.",
  businessDiagnosisStep7RsppLabel: "RSPP - Rappresentante per la Sicurezza e Prevenzione",
  businessDiagnosisStep7RsppHelp:
    "Indicare se il datore di lavoro ha nominato un responsabile per la sicurezza e prevenzione.",
  businessDiagnosisStep7RsppNameLabel: "RSPP indicare nominativo",
  businessDiagnosisStep7RsppNamePlaceholder: "Scrivere il nome della persona nominata come RSPP.",
  businessDiagnosisStep7DvrLabel: "DVR - Documento di Valutazione dei Rischi",
  businessDiagnosisStep7DvrHelp: "Documento di valutazione dei rischi.",
  businessDiagnosisStep7DuvriLabel:
    "DUVRI - Documento Unico di Valutazione dei Rischi da Interferenze",
  businessDiagnosisStep7DuvriHelp:
    "Indicare se è presente il documento che valuta i rischi derivanti da attività di terzi in azienda.",

  // Step 8
  businessDiagnosisStep8LabelSocialMediaPresence: "Presenza su social",
  businessDiagnosisStep8LabelECommerce: "E-commerce",
  businessDiagnosisStep8LabelGenderEqualityCertification: "Certificazione Parità di Genere",
  businessDiagnosisStep8LabelIso: "Iso",
  businessDiagnosisStep8IsoWhichLabel: "Indicare quali",
  businessDiagnosisStep8LabelCyberSecurity: "Cyber Sicurity",
  businessDiagnosisStep8LabelGdpr: "DGPR",
  businessDiagnosisStep8LabelSubsidizedFinance: "Utilizzo di Finanza Agevolata",
  businessDiagnosisStep8LabelFundedTraining: "Utilizzo di Formazione Finanziata",
  businessDiagnosisStep8LabelHasLiquidityManager: "Hai un gestore per la liquidità dell'azienda",
  businessDiagnosisStep8LabelDiversifiedLiquidityWithGold:
    "Hai diversificato la liquidità dell'azienda acquistando oro",
  businessDiagnosisStep8LabelDate: "Data: ",
  businessDiagnosisStep8LabelConsultant: "Consulente: ",
};

export default businessDiagnosisDictIT;
